import { createContext } from 'react'
import type { AppSession, LoginCredentials } from '../domain/auth'

export interface AuthContextValue {
  session: AppSession | null
  loading: boolean
  signIn: (credentials: LoginCredentials) => Promise<AppSession>
  signOut: () => Promise<void>
  requestPasswordReset: (email: string) => Promise<void>
  updatePassword: (password: string) => Promise<void>
  replaceTemporaryPassword: (currentPassword: string, newPassword: string) => Promise<AppSession>
}

export const AuthContext = createContext<AuthContextValue | null>(null)
